import { Icon } from '@chakra-ui/react';

export const BackCaretSvg = (): JSX.Element => {
  return (
    <Icon>
      <svg
        width="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.47541 11.7489C7.1093 12.0837 6.5157 12.0837 6.14959 11.7489L0.524588 6.60609C0.158472 6.27136 0.158472 5.72864 0.524588 5.39391L6.14959 0.251051C6.5157 -0.0836841 7.1093 -0.083684 7.47541 0.251051C7.84153 0.585786 7.84153 1.1285 7.47541 1.46323L2.51333 6L7.47541 10.5368C7.84153 10.8715 7.84153 11.4142 7.47541 11.7489Z"
          fill="#F2F2F2"
        />
      </svg>
    </Icon>
  );
};
